
export default {
  fancyCount: (state) => `${state.count}#`,
}
